<template>
    <f7-page name="CourseEnd">
        <f7-navbar
            :title-large="`Well done!`"
            large
            no-hairline
            large-transparent
        >
            <f7-nav-left>
                <!-- <f7-link
                    back
                    icon="ion-ios-arrow-left"
                    style="color: gray"
                /> -->
            </f7-nav-left>
            <f7-nav-title>Well done!</f7-nav-title>
            <f7-nav-right>
                <!-- <f7-link
                    href="#"
                    style="padding-right: 10px"
                    @click="closePopup"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                    >
                        <g
                            fill="none"
                            fill-rule="evenodd"
                            stroke="gray"
                            stroke-linecap="square"
                            stroke-width=".75"
                            transform="translate(-2)"
                        >
                            <path d="M3,1 L18,16" />
                            <path
                                d="M4.29545455,0.293103448 L16.7045455,16.7068966"
                                transform="rotate(78 10.5 8.5)"
                            />
                        </g>
                    </svg>
                </f7-link> -->
            </f7-nav-right>
        </f7-navbar>

        <f7-block style="margin-top: 6px">

            <h2>You have completed</h2>
            <div class="swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-ios">
                <div
                    class="swiper-wrapper"
                    style="width: 164px; margin: 50px auto; text-align: left"
                >
                    <course-card
                        :course="course"
                        :topic="topicsIndex[course.topicId]"
                        :link="`/courses/${course.id}`"
                        :key="`t-next-c-anim`"
                        :complete-anim="true"
                    />
                </div>
            </div>
            <p>
                <a :href="`/courses/${course.id}/feedback`">Have feedback?</a>
            </p>
            <div class="ansButtons">
                <f7-button
                    v-if="isFirstTracker()"
                    color="red"
                    fill
                    round
                    @click="goToFirstTracker"
                >
                    Continue
                </f7-button>
                <f7-button
                    v-else
                    color="red"
                    fill
                    href="#"
                    round
                    @click="closePopup()"
                >
                    Continue
                </f7-button>
                <!--  v-else-if="course.id !== user.currentCourseId"
                <f7-button
                    v-else
                    :href="`/courses/${course.id}/nextup`"
                    color="red"
                    fill
                    round
                >
                    Continue
                </f7-button>
-->
            </div>
        </f7-block>

    </f7-page>
</template>

<script>
import CourseCard from '../../components/courseCard.vue';
import {
    CORAL_BRANDING,
    FEELING_PRESENT_IN_YOUR_BODY,
    CREATING_SPACE_FOR_SEX
} from '../../js/constants';

export default {
    store: ['api', 'user', 'topics', 'topicsIndex', 'courses', 'coursesIndex', 'myTopics'],
    components: {
        CourseCard
    },
    data () {
        return {
            course: {
                name: '',
                id: ''
            },
            currentId: 0,
            slideIndex: 0,
            renderSub: 0,
            mySwiper: null
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    created: function () {
        if (this.$f7route.params.id) {
            this.currentId = parseFloat(this.$f7route.params.id);
        }
        if (this.currentId === FEELING_PRESENT_IN_YOUR_BODY) {
            // We should avoid magic numbers and set all such kind of things to variables in order to allow
            // codebase be maintainable and easyreadable
            const onBoardingTopicId = 58;

            // remove onboarding goal if completed but should be handled after page reloading,
            // as it works only for current screen once
            // TODO Should be handled on a back end maybe
            const index = this.myTopics.indexOf(onBoardingTopicId);
            if (index > -1) {
                this.myTopics.splice(index, 1);
            }
        }
        this.course = this.coursesIndex[this.currentId];
    },
    mounted: function () { },
    methods: {
        isFirstTracker: function () {
            return [CORAL_BRANDING, FEELING_PRESENT_IN_YOUR_BODY].includes(this.course.id) && !localStore.getItem('trackerTakenOnce');
        },
        goToFirstTracker: function () {
            this.user.currentCourseId = parseFloat(this.user.currentCourseId);
            if (this.user.currentCourseId === CORAL_BRANDING || this.user.currentCourseId === FEELING_PRESENT_IN_YOUR_BODY) {
                this.user.currentCourseId = CREATING_SPACE_FOR_SEX;
            }
            this.$events.fire('user-save');
            setTimeout(() => {
                this.$f7router.view.router.navigate('/firstTracker', { clearPreviousHistory: true });
            }, 200);
        },
        closePopup: function () {
            if (this.$f7router.view.main) {
                f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
            } else {
                if (f7.popup.get(`#${this.$f7router.view.name}`)) {
                    f7.popup.get(`#${this.$f7router.view.name}`).open();
                    f7.popup.get(`#${this.$f7router.view.name}`).close();
                }
            }
            if (!pgap) window.history.pushState(null, "", '/web' + f7.views['main'].router.currentRoute.path);
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../css/colors.less';
.center {
    text-align: center;
    width: 100%;
}
.bottom {
    position: absolute;
    bottom: 40px;
}
.coralButton {
    font-size: 18px;
    color: white;
    background: #a5acc4;
    border-radius: 22px;
    padding: 15px 30px;
}
#slides {
    height: 100%;
    padding-top: 0px;
}
.checkmark {
    z-index: 9999;
    margin: 50px auto 0;
    left: 50%;
    line-height: 67px;
    background: @coral;
    color: white;
    height: 70px;
    width: 70px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    i {
        color: white;
        font-size: 40px;
        line-height: 78px;
    }
}
.courseImage {
    margin: 0 auto;
    width: 120px;
    height: 120px;
    background-color: #eee;
    border-radius: 16px;
    box-shadow: 0px 5px 25px -10px rgba(0, 0, 0, 0.7);
    background-size: cover;
}
.miniProgress {
    width: 50px;
    overflow: hidden;
    height: 4px;
    background: #eee;
    top: 10px;
    position: absolute;
    left: 135px;
    border-radius: 3px;
    .miniProgressBar {
        height: 4px;
        border-radius: 3px;
        background: @green;
    }
}
</style>
